import 'reflect-metadata';

import { Container } from 'inversify';

import { InversifyContainer } from '../../shared/abstract/infrastructrue/Inversify.container';
import { UnifiedRolesEditor } from './domain/UnifiedRolesEditor';
import { UnifiedRolesEditorPolicyResolver } from './domain/UnifiedRolesEditorPolicy.resolver';
import { UnifiedRolesAdapter } from './infrastructure/adapters/UnifiedRoles.adapter';
import { UnifiedRolesFactory } from './infrastructure/factories/UnifiedRoles.factory';

export class UnifiedRolesDomainContainer extends InversifyContainer {
  static create(): Container {
    return this.buildInversifyIOCContainer([
      UnifiedRolesAdapter,
      UnifiedRolesEditor,
      UnifiedRolesFactory,
      UnifiedRolesEditorPolicyResolver,
    ]);
  }
}
